import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import calLogo from '../../assets/images/calender.svg';
import chevRight from '../../assets/images/chev-right.svg';
import SortIcon from '../../assets/images/sort-icon.svg';
import Checkbox from "../../components/layouts/CheckBox";
import CustomModal from "../../components/layouts/CustomModal";
import Button from "../../components/ui/Button";
import CustomInput from "../../components/ui/CustomInput";
import CustomReactSelect from "../../components/ui/CustomReactSelect";
import Skeleton from "../../components/ui/Skeleton";
import { ApiConstants } from "../../constants/ApiConstants";
import { HOUSEHOLD_TYPES, USER_ROLE_TYPES } from "../../constants/Constants";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { generateUniqueId, getDateHelper, getFrequencyDates, isDateFinalized, setDateHelper } from "../../utils/Helper";
import EditAllChores from "./EditAllChores";
import EditChores from "./EditChores";
import MarkAsCompleted from "./MarkAsCompleted";


const ChoresList = ({ doneByOptions, statusOptions, choresOptions, choresCreate, setFinalizedMonths, isRefresh, setIsRefresh }: any) => {

    const chores = useMakeRequest();
    let profile: any = useContext(authContext);
    profile = profile?.data;

    const choreReminder = useMakeRequest();
    const updateChores = useMakeRequest();
    const hhMembers = useMakeRequest();
    const scrollDivRef: any = useRef(null);

    const [isChoreChartExpanded, setIsChoreChartExpanded] = useState(true);

    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const [choresFilter, setChoresFilter]: any = useState();
    const [choresList, setChoresList] = useState<any[]>([]);
    const [filteredChoresList, setFilteredChoresList] = useState<any[]>([]);
    const [editChores, setEditChores] = useState(null);

    const [hoursMemberWise, setHoursMemberWise] = useState<{ [key: string]: { name: string; profile_pic: string; email: string; hours_spent: number } }>({})
    const [choresTotalHourPrice, setChoresTotalHourPrice] = useState({
        total_hours: 0, total_amount: 0,
        total_hours_completed: 0, total_amount_completed: 0, total_hours_projected: 0, total_amount_projected: 0
    })

    const [filteredHoursMemberWise, setFilteredHoursMemberWise] = useState<{ [key: string]: { name: string; profile_pic: string; email: string; hours_spent: number } }>({})
    const [completedHoursMemberWise, setCompletedHoursMemberWise] = useState<{ [key: string]: { name: string; profile_pic: string; email: string; hours_spent: number } }>({})
    const [filteredChoresTotalHourPrice, setFilteredChoresTotalHourPrice] = useState({ total_hours: 0, total_amount: 0, total_hours_completed: 0, total_amount_completed: 0, total_hours_projected: 0, total_amount_projected: 0 })
    const [deleteData, setDeleteData]: any = useState(null);

    const [showDeleteAllChoresModal, setShowDeleteAllChoresModal] = useState(false)
    const [showDeleteChoreModal, setShowDeleteChoreModal] = useState(false)

    const [selectedChores, setSelectedChores] = useState<string[]>([]);
    const [selectedChoresDate, setSelectedChoresDate] = useState<string[]>([]);
    const [selectedChoresArrayObj, setSelectedChoresArrayObj] = useState<any[]>([]);

    const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>({
        totalHours: false,
        totalExpenses: false,
        totalPaid: false,
        totalUnpaid: false,
        currentBalances: false,
        finalizedBalances: false
    });

    const [isOpen, setIsOpen] = useState(true);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const minutesToHour = (minutes: any) => {
        return (minutes / 60).toFixed(2);
    };

    const toggleSelectChore = (stableId: string, date: string, item: any) => {
        setSelectedChoresDate(prev =>
            prev.includes(date) ? prev.filter(dt => dt !== date) : [...prev, date]
        );

        setSelectedChores(prev => {
            const isSelected = prev.includes(stableId);

            if (isSelected) {
                setSelectedChoresArrayObj(prevArr =>
                    prevArr.filter(e => {
                        const itemStableId = `${e.c_id}-${e.m_date}`;
                        return itemStableId !== stableId;
                    })
                );
                return prev.filter(cid => cid !== stableId);
            } else {
                const transformed = {
                    c_id: item.uuid,
                    unique_id: stableId,
                    m_date: item.date,
                    new_date: item.s_date.split("T")[0],
                    d_by: item.done_by?.value || "",
                    is_modified: item.is_modified,
                    is_deleted: 1,
                    desc: item.description,
                    status: item.status,
                    h_spent: item.hour_spent
                };

                setSelectedChoresArrayObj(prevArr => [...prevArr, transformed]);
                return [...prev, stableId];
            }
        });
    };

    // Calculate allowed chores first
    const isAdmin = profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN;

    const allowedChores = isAdmin
        ? filteredChoresList.filter(chore => !chore.is_finalized)
        : filteredChoresList.filter(chore => {
            const isUnassigned = chore.status == 1;
            const isCreatedByMe = Number(chore?.createdBy) === Number(profile?.id);
            const isHouseholdAdmin = profile?.hh_member?.member_type === HOUSEHOLD_TYPES?.ADMIN;
            const isAssignedToMe = chore?.done_by?.value === profile?.uuid;

            return !chore.is_finalized && (isUnassigned || isCreatedByMe || isHouseholdAdmin || isAssignedToMe);
        });

    const hasNonEditable = allowedChores?.length <= 0;

    const allSelected =
        allowedChores.length > 0 &&
        selectedChores.length === allowedChores.length;



    const toggleSelectAll = () => {
        if (allSelected) {
            setSelectedChores([]);
            setSelectedChoresArrayObj([]);
            setSelectedChoresDate([]);
            return;
        }

        // Create stable IDs using uuid-date combination
        const allIds = allowedChores.map(chore => `${chore.uuid}-${chore.date}`);
        const allDates = allowedChores.map(chore => chore.date);

        const transformed = allowedChores.map(item => ({
            c_id: item.uuid,
            unique_id: `${item.uuid}-${item.date}`, // Use stable ID
            m_date: item.date,
            new_date: item.s_date.split("T")[0],
            d_by: item.done_by?.value || "",
            is_modified: item.is_modified,
            is_deleted: 1,
            desc: item.description,
            status: item.status,
            h_spent: item.hour_spent
        }));

        setSelectedChores(allIds);
        setSelectedChoresDate(allDates);
        setSelectedChoresArrayObj(transformed);
    };



    useEffect(() => {
        chores.makeRequest({ url: ApiConstants?.ChoresGet })
        setChoresFilter({
            s_date: null,
            e_date: null,
            h_spent: '',
            done_by: null,
            cc_id: null
        });
    }, [choresCreate?.status])

    useEffect(() => {
        hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
    }, [])

    useEffect(() => {
        if (chores?.status && hhMembers?.status) {
            const choresRows = chores?.data?.data?.rows;
            const modifiedChoreses = chores?.data?.data?.modified_chores;
            const choresArr: any = [];
            const hoursMemberWiseArr: any = {};
            let totalChoresHour = 0;
            let totalChoresAmount = 0;
            let totalCompletedHours = 0;
            let totalCompletedAmount = 0;

            hhMembers?.data?.data?.forEach((member: any) => {
                const userUUID = member?.user?.uuid;
                if (userUUID) {
                    hoursMemberWiseArr[userUUID] = {
                        name: member?.user?.name,
                        profile_pic: member?.user?.profile_pic,
                        email: member?.user?.email,
                        hours_spent: 0
                    };
                }
            });

            setFinalizedMonths(chores?.data?.data?.finalized_months || []);

            if (choresRows?.length > 0) {
                choresRows?.forEach((choresData: any) => {
                    const sDate = choresData?.s_date;
                    const eDate = choresData?.e_date;
                    const fType = choresData?.f_type;
                    const fValue = choresData?.f_value;
                    const hSpent = choresData?.h_spent;
                    const cName = choresData?.chores_cat;
                    const dBy = choresData?.done_by;
                    const description = choresData?.description;
                    const status = choresData?.status;
                    const selectedDaysOrMonths = choresData?.s_days_or_months;

                    const freqDays = getFrequencyDates(
                        sDate,
                        eDate,
                        fType,
                        fValue,
                        selectedDaysOrMonths,
                    );

                    const mappedChores = freqDays.map((date: string) => {
                        console.log("date - - - - - ->", date)
                        const is_finalized = isDateFinalized(date, chores?.data?.data?.finalized_months || []);

                        // FIX: Find modified chore for this specific date
                        const modifiedChores = modifiedChoreses.find(
                            (modChores: any) => {
                                return (
                                    modChores.c_id === choresData?.id &&
                                    moment(modChores.m_date).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD')
                                )
                            });

                        // Check member join date
                        if (profile?.hh_member?.member_type != HOUSEHOLD_TYPES?.ADMIN) {
                            if (moment(date).isBefore(moment(profile?.hh_member?.created_at).format('YYYY-MM-DD'))) {
                                return null;
                            }
                        }

                        // Skip deleted modified chores
                        if (modifiedChores && modifiedChores?.is_deleted) {
                            return null;
                        }

                        // FIX: Generate unique_id including date
                        const unique_id = `${choresData?.uuid}-${date}`;
                        console.log("modifiedChores: ", modifiedChores)
                        if (modifiedChores) {
                            console.log("modifiedChores?.done_by: ", modifiedChores?.done_by)
                            console.log("dBy: ", dBy)
                            return {
                                ...choresData,
                                ...modifiedChores,
                                date,
                                hour_spent: minutesToHour(modifiedChores?.m_h_spent),
                                chores: cName,
                                done_by: modifiedChores?.done_by || dBy,
                                minutes_spent: modifiedChores?.m_h_spent,
                                is_modified: true,
                                amount: modifiedChores?.amount,
                                description: modifiedChores?.description,
                                status: modifiedChores?.status,
                                is_finalized,
                                unique_id,
                                d_by: modifiedChores?.done_by?.value || choresData?.d_by // Add this for permission check
                            };
                        } else {
                            return {
                                date,
                                ...choresData,
                                minutes_spent: hSpent,
                                hour_spent: minutesToHour(hSpent),
                                chores: cName,
                                done_by: dBy,
                                is_modified: false,
                                description: description,
                                status: status,
                                is_finalized,
                                unique_id,
                                d_by: choresData?.d_by // Add this for permission check
                            };
                        }
                    }).filter(Boolean);
                    console.log("mappedChores: ", mappedChores)
                    choresArr.push(...mappedChores);

                    mappedChores.forEach((chore: any) => {
                        const memberUUID = chore.done_by?.value;
                        if (memberUUID && hoursMemberWiseArr[memberUUID]) {
                            hoursMemberWiseArr[memberUUID].hours_spent += chore.minutes_spent;
                        }

                        totalChoresHour += chore.minutes_spent;
                        totalChoresAmount += Number(chore?.c_price) * Number(chore?.hour_spent);

                        if (chore?.status === 3) {
                            totalCompletedHours += chore.minutes_spent;
                            totalCompletedAmount += Number(chore?.c_price) * Number(chore?.hour_spent);
                        }
                    });
                });

                choresArr.sort((a: any, b: any) => moment(a.date).valueOf() - moment(b.date).valueOf());
            }

            setChoresTotalHourPrice({
                total_hours: totalChoresHour,
                total_amount: totalChoresAmount,
                total_hours_completed: totalCompletedHours,
                total_amount_completed: parseFloat(totalCompletedAmount.toFixed(2)),
                total_hours_projected: totalChoresHour,
                total_amount_projected: parseFloat(totalChoresAmount.toFixed(2))
            });

            setFilteredChoresTotalHourPrice({
                total_hours: totalChoresHour,
                total_amount: totalChoresAmount,
                total_hours_completed: totalCompletedHours,
                total_amount_completed: parseFloat(totalCompletedAmount.toFixed(2)),
                total_hours_projected: totalChoresHour,
                total_amount_projected: parseFloat(totalChoresAmount.toFixed(2))
            });

            setHoursMemberWise(hoursMemberWiseArr);
            setFilteredHoursMemberWise(hoursMemberWiseArr);
            setChoresList(choresArr);
            setFilteredChoresList(choresArr);
        }
    }, [chores?.status, hhMembers?.status]);

    // useEffect(() => {
    //     if (chores?.status && hhMembers?.status) {
    //         const choresRows = chores?.data?.data?.rows;
    //         const modifiedChoreses = chores?.data?.data?.modified_chores;
    //         const choresArr: any = [];
    //         const hoursMemberWiseArr: any = {};
    //         const completedHoursMemberWiseArr: any = {};

    //         let totalChoresHour = 0;
    //         let totalChoresAmount = 0;
    //         let totalCompletedHours = 0;
    //         let totalCompletedAmount = 0;

    //         hhMembers?.data?.data?.forEach((member: any) => {
    //             const userUUID = member?.user?.uuid;
    //             if (userUUID) {
    //                 hoursMemberWiseArr[userUUID] = {
    //                     name: member?.user?.name,
    //                     profile_pic: member?.user?.profile_pic,
    //                     email: member?.user?.email,
    //                     hours_spent: 0
    //                 };
    //                 completedHoursMemberWiseArr[userUUID] = {
    //                     name: member?.user?.name,
    //                     profile_pic: member?.user?.profile_pic,
    //                     email: member?.user?.email,
    //                     hours_spent: 0
    //                 };
    //             }
    //         });

    //         setFinalizedMonths(chores?.data?.data?.finalized_months || []);

    //         if (choresRows?.length > 0) {
    //             choresRows?.forEach((choresData: any) => {
    //                 const sDate = choresData?.s_date;
    //                 const eDate = choresData?.e_date;
    //                 const fType = choresData?.f_type;
    //                 const fValue = choresData?.f_value;
    //                 const hSpent = choresData?.h_spent;
    //                 const cName = choresData?.chores_cat;
    //                 const dBy = choresData?.done_by;
    //                 const description = choresData?.description;
    //                 const status = choresData?.status;
    //                 const selectedDaysOrMonths = choresData?.s_days_or_months;

    //                 const freqDays = getFrequencyDates(
    //                     sDate,
    //                     eDate,
    //                     fType,
    //                     fValue,
    //                     selectedDaysOrMonths,
    //                 );

    //                 console.log("freqDays: ", freqDays)

    //                 const mappedChores = freqDays.map((date: string) => {
    //                     const is_finalized = isDateFinalized(date, chores?.data?.data?.finalized_months || []);

    //                     const modifiedChores = modifiedChoreses.find(
    //                         (modChores: any) => {
    //                             const matches = moment(modChores.m_date).format('YYYY-MM-DD') === date && modChores.c_id === choresData?.id;
    //                             return matches;
    //                         }
    //                     );

    //                     if (profile?.hh_member?.member_type != HOUSEHOLD_TYPES?.ADMIN) {
    //                         if (moment(date).isBefore(moment(profile?.hh_member?.created_at).format('YYYY-MM-DD'))) {
    //                             return null;
    //                         }
    //                     }

    //                     if (modifiedChores && modifiedChores.is_deleted) {
    //                         return null;
    //                     }

    //                     if (modifiedChores) {
    //                         return {
    //                             ...choresData,
    //                             ...modifiedChores,
    //                             done_by: modifiedChores?.done_by || dBy,
    //                             date,
    //                             is_modified: true,
    //                             hour_spent: minutesToHour(modifiedChores?.m_h_spent),
    //                             minutes_spent: modifiedChores?.m_h_spent,
    //                             chores: cName,
    //                             amount: Number(choresData?.c_price) * Number(minutesToHour(modifiedChores?.m_h_spent)),
    //                             description: modifiedChores?.description == null ? description : modifiedChores?.description,
    //                             status: modifiedChores?.status,
    //                             is_finalized,
    //                             unique_id: generateUniqueId(modifiedChores?.uuid)
    //                         };
    //                     } else {
    //                         return {
    //                             date,
    //                             ...choresData,
    //                             done_by: dBy,
    //                             is_modified: false,
    //                             hour_spent: minutesToHour(hSpent),
    //                             minutes_spent: hSpent,
    //                             chores: cName,
    //                             amount: Number(choresData?.c_price) * Number(minutesToHour(hSpent)),
    //                             description: description,
    //                             status: status,
    //                             is_finalized,
    //                             unique_id: generateUniqueId(choresData?.uuid)
    //                         };
    //                     }
    //                 }).filter(Boolean);

    //                 choresArr.push(...mappedChores);

    //                 mappedChores.forEach((chore: any) => {
    //                     console.log("chore - - - - - - ->", chore)
    //                     const memberUUID = chore.done_by?.value;
    //                     if (memberUUID && hoursMemberWiseArr[memberUUID]) {
    //                         hoursMemberWiseArr[memberUUID].hours_spent += chore.minutes_spent;
    //                     }

    //                     totalChoresHour += chore.minutes_spent;
    //                     totalChoresAmount += Number(chore?.amount || 0);

    //                     if (chore?.status === 3) {
    //                         totalCompletedHours += chore.minutes_spent;
    //                         totalCompletedAmount += Number(chore?.amount || 0);
    //                         if (memberUUID && hoursMemberWiseArr[memberUUID]) {
    //                             completedHoursMemberWiseArr[memberUUID].hours_spent += chore.minutes_spent;
    //                         }
    //                     }
    //                 });
    //             });

    //             choresArr.sort((a: any, b: any) => moment(a.date).valueOf() - moment(b.date).valueOf());
    //         }

    //         setChoresTotalHourPrice({
    //             total_hours: totalChoresHour,
    //             total_amount: totalChoresAmount,
    //             total_hours_completed: totalCompletedHours,
    //             total_amount_completed: parseFloat(totalCompletedAmount.toFixed(2)),
    //             total_hours_projected: totalChoresHour,
    //             total_amount_projected: parseFloat(totalChoresAmount.toFixed(2))
    //         });

    //         setFilteredChoresTotalHourPrice({
    //             total_hours: totalChoresHour,
    //             total_amount: totalChoresAmount,
    //             total_hours_completed: totalCompletedHours,
    //             total_amount_completed: parseFloat(totalCompletedAmount.toFixed(2)),
    //             total_hours_projected: totalChoresHour,
    //             total_amount_projected: parseFloat(totalChoresAmount.toFixed(2))
    //         });
    //         console.log("hoursMemberWiseArr: ", hoursMemberWiseArr)
    //         setHoursMemberWise(hoursMemberWiseArr);
    //         setCompletedHoursMemberWise(completedHoursMemberWiseArr);
    //         setFilteredHoursMemberWise(hoursMemberWiseArr);
    //         setChoresList(choresArr);
    //         setFilteredChoresList(choresArr);
    //     }
    // }, [chores?.status, hhMembers?.status]);


    const handleScroll = () => {
        return
        // if (page <= getPastRides?.data?.data?.last_page) {
        // const div = scrollDivRef?.current;
        // if (div) {
        //     const { scrollTop, scrollHeight, clientHeight } = div;
        //     if ((Math.round((scrollTop + clientHeight) * 100 / scrollHeight) === 100)) {
        //         setPage(page + 1);
        //     }
        // }
        // }
    };

    const handleFilter = (type: string = 'FILTER') => {
        if (type === 'RESET') {
            setChoresFilter({
                s_date: null,
                e_date: null,
                h_spent: '',
                done_by: null,
                cc_id: null,
                status: null
            });

            setFilteredChoresList(choresList);
            setFilteredChoresTotalHourPrice(choresTotalHourPrice);
            setFilteredHoursMemberWise(hoursMemberWise);
            return;
        }

        let { cc_id, done_by, s_date, e_date, h_spent, status } = choresFilter || {};

        const choreId = cc_id?.value;
        const memberId = done_by?.value;
        const statusValue = status?.value;

        const filteredChores = choresList.filter((chore: any) => {
            let isMatch = true;

            // ✅ Filter by Chore
            if (choreId && chore?.chores?.value !== choreId) {
                isMatch = false;
            }

            // ✅ Filter by Member
            if (memberId && chore?.done_by?.value !== memberId) {
                isMatch = false;
            }

            // ✅ Filter by Status
            if (statusValue && chore?.status !== statusValue) {
                isMatch = false;
            }

            // ✅ Filter by Hours
            if (h_spent && Number(chore?.hour_spent) !== Number(h_spent)) {
                isMatch = false;
            }

            // ✅ Filter by Date Range
            const choreDate = moment(chore?.date);

            if (s_date && !e_date) {
                if (choreDate.isBefore(moment(s_date).startOf('day'))) {
                    isMatch = false;
                }
            }

            if (!s_date && e_date) {
                if (choreDate.isAfter(moment(e_date).endOf('day'))) {
                    isMatch = false;
                }
            }

            if (s_date && e_date) {
                if (
                    choreDate.isBefore(moment(s_date).startOf('day')) ||
                    choreDate.isAfter(moment(e_date).endOf('day'))
                ) {
                    isMatch = false;
                }
            }

            return isMatch;
        });

        // ===============================
        // Totals Calculation
        // ===============================

        const totalFilteredHours = filteredChores.reduce((sum: number, chore: any) => {
            return sum + chore.minutes_spent;
        }, 0);

        const totalFilteredAmount = filteredChores.reduce((sum: number, chore: any) => {
            return sum + Number(chore?.c_price * chore?.hour_spent);
        }, 0);

        const filteredCompletedChores = filteredChores.filter(
            (chore: any) => chore.status === 3
        );

        const totalCompletedHours = filteredCompletedChores.reduce((sum: number, chore: any) => {
            return sum + chore.minutes_spent;
        }, 0);

        const totalCompletedAmount = filteredCompletedChores.reduce((sum: number, chore: any) => {
            return sum + Number(chore?.c_price * chore?.hour_spent);
        }, 0);

        // ===============================
        // Member Wise Hours
        // ===============================

        const filteredHoursMemberWiseArr: any = {};

        hhMembers?.data?.data?.forEach((member: any) => {
            const userUUID = member?.user?.uuid;

            if (userUUID) {
                filteredHoursMemberWiseArr[userUUID] = {
                    name: member?.user?.name,
                    profile_pic: member?.user?.profile_pic,
                    email: member?.user?.email,
                    hours_spent: 0
                };
            }
        });

        filteredChores.forEach((chore: any) => {
            const memberUUID = chore.done_by?.value;

            if (memberUUID && filteredHoursMemberWiseArr[memberUUID]) {
                filteredHoursMemberWiseArr[memberUUID].hours_spent += chore.minutes_spent;
            }
        });

        setFilteredChoresTotalHourPrice({
            total_hours: totalFilteredHours,
            total_amount: parseFloat(totalFilteredAmount.toFixed(2)),
            total_hours_projected: totalFilteredHours,
            total_amount_projected: parseFloat(totalFilteredAmount.toFixed(2)),
            total_hours_completed: totalCompletedHours,
            total_amount_completed: parseFloat(totalCompletedAmount.toFixed(2))
        });

        setFilteredHoursMemberWise(filteredHoursMemberWiseArr);
        setFilteredChoresList(filteredChores);
    };


    const handleDeleteChores = () => {
        updateChores.makeRequest({
            url: ApiConstants?.ChoresUpdate,
            payload: {
                c_id: deleteData?.uuid,
                is_deleted: true,
                m_date: deleteData?.date,
                is_modified: deleteData?.is_modified
            }
        })
    }
    console.log("selectedChoresArrayObj: ", selectedChoresArrayObj);

    const handleDeleteAllChores = () => {
        toast.promise(
            updateChores.makeRequest({ payload: selectedChoresArrayObj, url: ApiConstants?.AllChoresUpdate }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
    }

    useEffect(() => {
        if (updateChores?.status) {
            $('.btn-close-modal').click()
            $('.btn-close-all-chores-modal').click()
            setDeleteData(null)
            setSelectedChores([])
            setSelectedChoresArrayObj([]);
            setShowDeleteAllChoresModal(false)
            setShowDeleteChoreModal(false)
            chores.makeRequest({ url: ApiConstants?.ChoresGet })
        }
    }, [updateChores?.status])


    useEffect(() => {
        if (isRefresh) {
            setChoresFilter({
                s_date: null,
                e_date: null,
                h_spent: '',
                done_by: null,
                cc_id: null
            });
            setFilteredChoresList(choresList);
            setFilteredChoresTotalHourPrice(choresTotalHourPrice);
            setFilteredHoursMemberWise(hoursMemberWise);
            chores.makeRequest({ url: ApiConstants?.ChoresGet })
        }
    }, [isRefresh])

    useEffect(() => {
        return () => {
            $('.modal-backdrop').remove();
        }
    }, [])

    const getStatus = (status: number) => {
        return status == 1 ? 'Unassigned' : status == 2 ? 'Assigned' : status == 3 ? 'Completed' : ""
    }


    const handleSort = (key: any) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const toggleSection = (section: string) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    }


    return (
        <>
            <div className="page-padding-x box-bg pt-2">
                <div className="com-input-grp mb-4 mt-2">
                    <div className="input-header">
                        <label className="form-label-large">Chore Chart</label>
                        <div className="filter-section" onClick={() => setIsChoreChartExpanded(!isChoreChartExpanded)} style={{ cursor: 'pointer' }}>
                            <span>Filter</span>
                            <img
                                src={chevRight}
                                alt="chevron"
                                style={{
                                    transform: isChoreChartExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            />
                        </div>
                    </div>
                </div>

                {isChoreChartExpanded && (
                    <>
                        <div className="row gy-3">
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">Start Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="Select Date"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={choresFilter?.s_date ? moment(choresFilter?.s_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setChoresFilter({ ...choresFilter, s_date: setDateHelper({ date: start_date }), e_date: '' })
                                        }}
                                        minDate={moment(profile?.hh_member?.billing_date).toDate()}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">End Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="Select Date"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={choresFilter?.e_date ? moment(choresFilter?.e_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setChoresFilter({ ...choresFilter, e_date: setDateHelper({ date: start_date }) })
                                        }}
                                        minDate={new Date(new Date(choresFilter?.s_date).setDate(new Date(choresFilter?.s_date).getDate() + 1))}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <CustomReactSelect
                                    label="Status"
                                    value={choresFilter?.status}
                                    options={[{ value: 1, label: "Unassigned" }, { value: 2, label: "Assigned" }, { value: 3, label: "Completed" },]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Status"
                                    onChange={(selectedOption: any) => {
                                        setChoresFilter({ ...choresFilter, status: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />
                            </div>
                            <div className="col-6">
                                <CustomReactSelect
                                    label="Member"
                                    value={choresFilter?.done_by}
                                    options={[
                                        ...(Array.isArray(doneByOptions) ? doneByOptions : []),
                                    ]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Member"
                                    isLoading={hhMembers?.loading}
                                    onChange={(selectedOption) => {
                                        setChoresFilter({ ...choresFilter, done_by: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />
                            </div>
                            <div className="col-6">
                                <CustomReactSelect
                                    label="Chore"
                                    value={choresFilter?.cc_id}
                                    options={[...choresOptions]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Chores"
                                    onChange={(selectedOption: any) => {
                                        setChoresFilter({ ...choresFilter, cc_id: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />
                            </div>
                            <div className="col-6">
                                <CustomInput
                                    label="Hours"
                                    type="text"
                                    className="form-control"
                                    placeholder='Select Hours'
                                    max={24}
                                    min={0}
                                    value={choresFilter?.h_spent}

                                    onInput={(e: any) => {
                                        let value = e.target.value.replace(/[^0-9.]/g, '');
                                        if (value === '') {
                                            setChoresFilter({ ...choresFilter, h_spent: '' })
                                            return;
                                        }
                                        if (value.includes('.') && parseInt(value.split('.')[0]) >= 24) { return; }
                                        if (value.match(/^\d{1,2}(\.\d{0,2})?$/)) {
                                            const [hours, minutes] = value.split('.');
                                            if (parseInt(hours) > 24) { value = '24'; }
                                            if (minutes && parseInt(minutes) > 59) {
                                                value = `${hours}.59`;
                                            }
                                            e.target.value = value;
                                            setChoresFilter({ ...choresFilter, h_spent: value })
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div className='pb-4 d-flex'>
                            <Button className='custom-grayed-btn modal-light-btn mt-2 me-4 ' type="button" style={{ width: "50%" }} onClick={() => handleFilter('RESET')}>Reset</Button>
                            <Button className='com-btn mt-2' type="button" style={{ width: "50%" }} onClick={handleFilter}>Filter</Button>
                        </div>
                    </>
                )}
            </div>

            <div className="box-bg pt-2">
                <div className="page-padding-x">
                    <div className="table-scroll-top" >
                        <div className='table-responsive table-y-scroll-2 report-table mb-2' ref={scrollDivRef} onScroll={handleScroll}>
                            <table className='table'>
                                <thead>
                                    <tr>

                                        <th>
                                            <Checkbox
                                                checked={allSelected}
                                                onChange={!hasNonEditable ? toggleSelectAll : undefined}
                                                disabled={hasNonEditable}
                                            />
                                            {/* <input
                                            type="checkbox"
                                            checked={allSelected}
                                            onChange={!hasNonEditable ? toggleSelectAll : undefined}
                                            disabled={hasNonEditable}
                                            className={`custom-checkbox ${hasNonEditable ? "checkbox-disabled" : ""}`}
                                        /> */}
                                        </th>
                                        <th>Date
                                            <img
                                                src={SortIcon}
                                                alt="Sort"
                                                className="sort-icon"
                                                onClick={() => handleSort('date')}
                                            />
                                        </th>
                                        <th className="text-center">Chore<img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('chores')}
                                        /></th>
                                        <th className="text-center">Hours<img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('hours')}
                                        /></th>
                                        <th className="text-center">Member<img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('member')}
                                        /></th>

                                        <th className="text-center">Description<img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('description')}
                                        /></th>
                                        <th className="text-center">Status<img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('status')}
                                        /></th>

                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        // filteredChoresList?.length > 0 ?
                                        chores?.loading ?
                                            Array.from({ length: 10 })?.map(() => (
                                                <tr>

                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '100px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '140px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                    </td>
                                                    <td className="text-center">
                                                        <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                    </td>
                                                </tr>
                                            )) :

                                            filteredChoresList?.length > 0 ?

                                                [...filteredChoresList]
                                                    ?.sort((a, b) => {
                                                        const { key, direction } = sortConfig;
                                                        if (!key) return 0;

                                                        let aValue, bValue;

                                                        switch (key) {
                                                            case 'date':
                                                                aValue = new Date(a.date);
                                                                bValue = new Date(b.date);
                                                                break;
                                                            case 'chores':
                                                                aValue = a.chores?.label?.toLowerCase();
                                                                bValue = b.chores?.label?.toLowerCase();
                                                                break;
                                                            case 'description':
                                                                aValue = a.description?.toLowerCase();
                                                                bValue = b.description?.toLowerCase();
                                                                break;
                                                            case 'status':
                                                                aValue = a.status;
                                                                bValue = b.status;
                                                                break;
                                                            case 'member':
                                                                aValue = a.done_by?.label?.toLowerCase();
                                                                bValue = b.done_by?.label?.toLowerCase();
                                                                break;
                                                            case 'hours':
                                                                aValue = parseFloat(a.hour_spent);
                                                                bValue = parseFloat(b.hour_spent);
                                                                break;
                                                            default:
                                                                return 0;
                                                        }

                                                        if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                                                        if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                                                        return 0;
                                                    })?.map((chore: any, choreIndex: any) => {
                                                        const date = getDateHelper({ date: chore?.date, format: 'MM/DD/YYYY' });
                                                        const hSpent = chore?.hour_spent;
                                                        const dBy = chore?.done_by?.label;
                                                        const cName = chore?.chores?.label;
                                                        const description = chore?.description;
                                                        const status = chore?.status;
                                                        let isHourExceed = false;
                                                        const isFinalized = chore?.is_finalized;
                                                        // const canEdit = Number(chore?.createdBy) === Number(profile?.id) ? 1 : profile?.hh_member?.member_type === HOUSEHOLD_TYPES?.ADMIN ? 1 : 0;
                                                        // const canEdit = chore.status == 1 ? 1 : Number(chore?.createdBy) === Number(profile?.id) ? 1 : profile?.hh_member?.member_type === HOUSEHOLD_TYPES?.ADMIN ? 1 : 0;
                                                        const isAssignedToMe = chore?.done_by?.value === profile?.uuid;
                                                        const isCreatedByMe = Number(chore?.createdBy) === Number(profile?.id);
                                                        const isAdminUser = profile?.hh_member?.member_type === HOUSEHOLD_TYPES?.ADMIN;
                                                        const isUnassigned = chore.status == 1;

                                                        const canEdit = isUnassigned || isCreatedByMe || isAdminUser || isAssignedToMe ? 1 : 0;
                                                        const stableId = `${chore.uuid}-${chore.date}`;
                                                        return (
                                                            <>
                                                                <tr className={isHourExceed ? 'row-error' : ''} key={choreIndex}>
                                                                    <td>
                                                                        <Checkbox
                                                                            id={`chore-checkbox-${stableId}`}
                                                                            checked={selectedChores.includes(stableId)}
                                                                            disabled={isFinalized}
                                                                            onChange={() => {
                                                                                const isAdmin = profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN;
                                                                                if (isAdmin || canEdit) {
                                                                                    toggleSelectChore(stableId, chore.date, chore)
                                                                                } else {
                                                                                    toast.error("You can edit chores that are unassigned, assigned to you, or created by you.");
                                                                                }
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>{date}</td>
                                                                    <td className="text-center">{cName}</td>
                                                                    <td className="text-center">{hSpent}</td>
                                                                    <td className="text-center">{getStatus(status) == 'Unassigned' ? "Unassigned" : dBy}</td>
                                                                    <td className="text-center">{description}</td>
                                                                    <td className="text-center">{getStatus(status)}</td>


                                                                    <td className='pay-status'>

                                                                        <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                                            <div className="modal-dialog">
                                                                                <div className="modal-content">
                                                                                    <div className="modal-header">
                                                                                        <h1 className="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
                                                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                                                    </div>
                                                                                    <div className="modal-body">
                                                                                        ...
                                                                                    </div>
                                                                                    <div className="modal-footer">
                                                                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                                                                        <button type="button" className="btn btn-primary">Save changes</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            {
                                                                                isFinalized ? 'Finalized' :
                                                                                    canEdit ?
                                                                                        <>
                                                                                            <span className="action-icon cursor-pointer"
                                                                                                role="button"
                                                                                                tabIndex={0}
                                                                                                onKeyDown={(e) => {
                                                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                                                        e.preventDefault();
                                                                                                        e.currentTarget.click();
                                                                                                    }
                                                                                                }}
                                                                                                data-bs-toggle="modal"
                                                                                                data-bs-target="#choresUpdateModal"
                                                                                                onMouseDown={(e) => e.preventDefault()}
                                                                                                onClick={(e: any) => {
                                                                                                    e.preventDefault();
                                                                                                    setSelectedChores([])
                                                                                                    setSelectedChoresArrayObj([]);
                                                                                                    setEditChores(chore)
                                                                                                }}
                                                                                            >
                                                                                                <svg
                                                                                                    className="edit-icon"
                                                                                                    width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                    <g clip-path="url(#clip0_58545_4835)">
                                                                                                        <path d="M6.98438 3.5L10.4934 7.00001" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                        <path d="M7.56836 12.832H12.8319" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                        <path d="M1.16804 9.33953L9.31264 1.17069C9.3162 1.16709 9.32203 1.16706 9.32565 1.17063L12.8281 4.66833C12.8304 4.67062 12.8304 4.6743 12.8281 4.67658L4.66333 12.8348H1.16797L1.16804 9.33953Z" stroke="#263C4A" stroke-width="0.875" />
                                                                                                    </g>
                                                                                                    <defs>
                                                                                                        <clipPath id="clip0_58545_4835">
                                                                                                            <rect width="14" height="14" fill="white" />
                                                                                                        </clipPath>
                                                                                                    </defs>
                                                                                                </svg>


                                                                                            </span>
                                                                                            <div className="vertical-icon-separator" />
                                                                                            <span
                                                                                                className="action-icon del cursor-pointer"
                                                                                                role="button"
                                                                                                tabIndex={0}
                                                                                                onKeyDown={(e) => {
                                                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                                                        e.preventDefault();
                                                                                                        e.currentTarget.click();
                                                                                                    }
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    setSelectedChores([])
                                                                                                    setSelectedChoresArrayObj([]);
                                                                                                    setDeleteData(chore)
                                                                                                    setShowDeleteChoreModal(true)

                                                                                                }}>
                                                                                                <svg className="del-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                    <path d="M5.25 6.70703H8.75" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                    <path d="M6.125 9.04297H7.875" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                    <path d="M11.375 3.20703L10.7917 12.832H3.20833L2.625 3.20703" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                    <path d="M1.16797 3.20964H4.66797M4.66797 3.20964L5.54297 1.16797H8.45964L9.33464 3.20964M4.66797 3.20964H9.33464M12.8346 3.20964H9.33464" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                                                                </svg>
                                                                                            </span>
                                                                                        </>
                                                                                        : '...'}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })
                                                :
                                                <>
                                                    <tr>
                                                        <td colSpan={20}>

                                                            <p className="text-center mt-3">No Record Found</p>
                                                        </td>
                                                    </tr>

                                                </>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>


                    <div className="d-flex align-items-center justify-content-center">
                        <button
                            className="com-btn me-2"
                            style={{ width: "50%" }}
                            data-bs-toggle={selectedChores?.length > 0 ? "modal" : ""}
                            data-bs-target={selectedChores?.length > 0 ? "#editAllChoresUpdateModal" : ""}
                            onClick={(e) => {
                                if (selectedChores?.length === 0) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="me-2 btn-icon"
                            >
                                <path
                                    d="M9.97754 5L14.9905 10"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M10.8135 18.334H18.3328"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M1.66709 13.3397L13.3022 1.66991C13.3073 1.66476 13.3156 1.66471 13.3208 1.66981L18.3243 6.66654C18.3276 6.6698 18.3276 6.67506 18.3243 6.67832L6.66037 18.3329H1.66699L1.66709 13.3397Z"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                />
                            </svg>

                            Edit
                        </button>
                        <button className="com-btn"
                            style={{ width: "50%" }}
                            // data-bs-toggle={selectedChores?.length > 0 ? "modal" : ""}
                            // data-bs-target={selectedChores?.length > 0 ? "#deleteAllChoresModal" : ""}
                            onClick={(e) => {
                                if (selectedChores?.length > 0) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setShowDeleteAllChoresModal(true)
                                }
                            }}
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="me-2 btn-icon"
                            >
                                <path
                                    d="M7.49902 9.58594H12.499"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M8.74902 12.9141H11.249"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M16.249 4.58594L15.4157 18.3359H4.58236L3.74902 4.58594"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M1.66797 4.58073H6.66797M6.66797 4.58073L7.91797 1.66406H12.0846L13.3346 4.58073M6.66797 4.58073H13.3346M18.3346 4.58073H13.3346"
                                    stroke="currentColor"
                                    stroke-width="1.04167"
                                    stroke-linejoin="round"
                                />
                            </svg>

                            Delete
                        </button>

                    </div>



                    <div className="d-flex align-items-center justify-content-center mt-2">
                        <button
                            className="com-btn me-2"
                            style={{ width: "50%" }}
                            data-bs-toggle={selectedChores?.length > 0 ? "modal" : ""}
                            data-bs-target={selectedChores?.length > 0 ? "#markAsCompletedModal" : ""}
                            onClick={(e) => {
                                if (selectedChores?.length === 0) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="me-2 btn-icon"
                            >
                                <path
                                    d="M3.33594 9.33202L5.66927 11.6654L12.6693 4.33203"
                                    stroke="currentColor"
                                    stroke-linecap="square"
                                />
                            </svg>

                            Mark as Completed
                        </button>
                        <button
                            className="com-btn"
                            style={{ width: "50%" }}
                            disabled={
                                choreReminder?.loading ||
                                (selectedChoresArrayObj.length > 0 &&
                                    selectedChoresArrayObj.every((chore: any) => Number(chore.status) === 3))
                            }
                            onClick={() => {

                                toast.promise(
                                    choreReminder.makeRequest({
                                        url: ApiConstants?.sendChoreReminder,
                                        payload: {
                                            hh_id: profile?.hh_member?.household?.id,
                                            c_ids: selectedChoresArrayObj.map((chore: any) => chore.c_id),
                                        }
                                    }),
                                    {
                                        loading: 'Processing...',
                                        success: (data: any) => data.message,
                                        error: (error: any) => error.message,
                                    }
                                );
                            }}>
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="me-2 btn-icon"
                            >
                                <path
                                    d="M12.9173 15C12.9173 16.6108 11.6115 17.9167 10.0007 17.9167C8.38982 17.9167 7.08398 16.6108 7.08398 15"
                                    stroke={"currentColor"}
                                    stroke-width="1.04167"
                                    stroke-linecap="square"
                                />
                                <path
                                    d="M16.0259 15.0007H3.97406C3.15996 15.0007 2.5 14.3407 2.5 13.5266C2.5 13.1357 2.6553 12.7607 2.93174 12.4842L4.16667 11.2493V7.91732C4.16667 4.69566 6.77834 2.08398 10 2.08398C13.2217 2.08398 15.8333 4.69565 15.8333 7.91732V11.2493L17.0682 12.4842C17.3447 12.7607 17.5 13.1357 17.5 13.5266C17.5 14.3407 16.84 15.0007 16.0259 15.0007Z"
                                    stroke={"currentColor"}
                                    stroke-width="1.04167"
                                    stroke-linecap="square"
                                />
                            </svg>

                            Send Reminder
                        </button>
                    </div>
                </div>
                <div className="divider" />
                <div className='summary-section'>
                    <h3 className='summary-title'>Summary</h3>

                    {/* Total Hours Projected */}
                    <div className='summary-item' tabIndex={0}>
                        <div className='summary-item-header'>
                            <span className='summary-item-label'>Total Hours Projected</span>
                            <span className='summary-item-value'>{minutesToHour(filteredChoresTotalHourPrice?.total_hours) || 0}</span>
                        </div>
                    </div>

                    {/* Total Hours Completed */}
                    <div
                        className='summary-item'
                        tabIndex={0}
                        role='button'
                        aria-expanded={expandedSections.totalHours}
                        onClick={() => toggleSection('totalHours')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleSection('totalHours');
                            }
                        }}
                    >
                        <div className='summary-item-header'>
                            <div className='summary-item-left'>
                                <span className='summary-item-label'>Total Hours Completed</span>
                                <span className='summary-item-arrow'>
                                    <img className={`accordion-arrow ${expandedSections.totalHours ? 'expanded' : ''}`} src={chevRight} alt="" />
                                </span>
                            </div>
                            <span className='summary-item-value'>
                                {minutesToHour(filteredChoresTotalHourPrice?.total_hours_completed) || 0}
                            </span>
                        </div>
                    </div>
                    {expandedSections.totalHours && (
                        <div className='summary-item-expanded'>
                            {Object.entries(completedHoursMemberWise).map(([id, user]) => {
                                console.log("user", user)
                                return (
                                    <div className='summary-sub-item' key={id}>
                                        <span className='summary-sub-label'>{user?.name}</span>
                                        <span className='summary-sub-value'>{minutesToHour(user?.hours_spent)}</span>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </div>

            </div >


            {showDeleteAllChoresModal &&
                <CustomModal
                    title='Are you sure you would like to delete these chores?'
                    buttonTxt={'Delete'}
                    onConfirm={handleDeleteAllChores}
                    toggleModal={() => {
                        setDeleteData(false)
                        setShowDeleteAllChoresModal(false)
                    }}
                />
            }
            {showDeleteChoreModal &&
                <CustomModal
                    title='Are you sure you would like to delete this chore?'
                    buttonTxt={'Delete'}
                    onConfirm={handleDeleteChores}
                    toggleModal={() => {
                        setDeleteData(false)
                        setShowDeleteChoreModal(false)
                    }}
                />
            }


            <EditChores
                finalizedMonths={chores?.data?.data?.finalized_months}
                editChores={editChores}
                doneByOptions={doneByOptions}
                onSuccess={() => {
                    chores.makeRequest({ url: ApiConstants?.ChoresGet })
                    setEditChores(null)
                }}
                onCancel={() => {
                    setEditChores(null)
                }}
            />

            <EditAllChores
                selectedChores={selectedChores}
                choresOptions={choresOptions}
                finalizedMonths={chores?.data?.data?.finalized_months}
                editChores={selectedChoresArrayObj}
                doneByOptions={doneByOptions}
                onSuccess={() => {
                    setSelectedChores([])
                    setSelectedChoresArrayObj([]);
                    chores.makeRequest({ url: ApiConstants?.ChoresGet })
                    setEditChores(null)
                }}
                onCancel={() => {
                    setEditChores(null)
                }}
            />

            <MarkAsCompleted
                selectedChores={selectedChores}
                editChores={selectedChoresArrayObj}
                doneByOptions={doneByOptions}
                onSuccess={() => {
                    chores.makeRequest({ url: ApiConstants?.ChoresGet })
                    setEditChores(null)
                    setSelectedChores([])
                    setSelectedChoresArrayObj([]);
                }}
                onCancel={() => {
                    setEditChores(null)
                    setSelectedChores([])
                    setSelectedChoresArrayObj([]);
                }}
            />


        </>
    )
}

export default ChoresList